import { atom } from 'jotai';
import { selectAtom } from 'jotai/utils';
// import { selectAtom } from "jotai/utils";

import callApi from 'lib/callApi';

export const vendorSearchAtom = atom('');
export const vendorPageNumberAtom = atom(1);
export const productSearchAtom = atom('');
export const productPageNumberAtom = atom(1);
export const selectedVendorAtom = atom('');

export const refreshSubscriptionsAtom = atom(Math.random());

export const subscriptionsDataAtom = atom(async (get) => {
  const reset = get(refreshSubscriptionsAtom);
  try {
    const response = await callApi('opencve/subscriptions', 'GET', {});
    return response.data ? response.data : [];
  } catch (error) {
    console.error(error);
    return [];
  }
});

export const vendorSubscriptionsAtom = selectAtom(
  subscriptionsDataAtom,
  (data) =>
    data.filter(
      (subscription) => subscription.vendor_name && !subscription.product_name,
    ),
);

export const productSubscriptionsAtom = selectAtom(
  subscriptionsDataAtom,
  (data) => data.filter((subscription) => subscription.product_name !== null),
);

export const vendorsDataAtom = atom(async (get) => {
  const searchKeyword = get(vendorSearchAtom);
  const vendorPage = get(vendorPageNumberAtom);
  try {
    const response = await callApi('opencve/vendors', 'GET', {
      search: searchKeyword,
      page: vendorPage,
    });
    return response.data?.data ? response.data.data : [];
  } catch (error) {
    console.error(error);
  }
  return [];
});

export const productsDataAtom = atom(async (get) => {
  const searchKeyword = get(productSearchAtom);
  const productPage = get(productPageNumberAtom);
  const selectedVendor = get(selectedVendorAtom);
  try {
    if (selectedVendor) {
      const response = await callApi('opencve/products', 'GET', {
        vendor: selectedVendor,
        search: searchKeyword,
        page: productPage,
      });
      return response.data?.data ? response.data.data : [];
    } else {
      return [];
    }
  } catch (error) {
    console.error(error);
  }
  return [];
});
